import styled from 'styled-components'

export const ParcelsCardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp32};
`
